import React, { useRef } from 'react';
import ReactPlayer from 'react-player';
import { CloseOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';

import Img from '../../../Img/Img';
import Badge from '../../../Badge';
import Anchor from '../../../link/Anchor';
import { Attachment } from '../types';
import { ATTACHMENT_TYPE } from '../constants';
import { PreviewStyle } from './style';

interface PreviewProps {
  data: Attachment;
  index: number;
  isOrder: boolean;
  isEditable: boolean;
  uploadVideo: (index: number, data?: Attachment) => void;
  uploadImage: (e: React.ChangeEvent<HTMLInputElement>, index?: number) => Promise<void>;
  previewAttachment: (data: Attachment) => void;
  deleteAttachment: (index: number) => void;
}
const Preview = (props: PreviewProps): JSX.Element => {
  const { data, index, isOrder, isEditable, uploadVideo, uploadImage, previewAttachment, deleteAttachment } = props;
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleClickUpdateAnchor = () => {
    data.type === ATTACHMENT_TYPE.VIDEO ? uploadVideo(index, data) : inputRef.current?.click();
  };

  return (
    <PreviewStyle>
      {data.type === ATTACHMENT_TYPE.VIDEO ? (
        <ReactPlayer className="react-player" width={140} height={140} light={true} url={data.url} />
      ) : (
        <Img clickAble={false} effect src={data.url} />
      )}
      {isOrder ? (
        <p className="orderNumber">
          {/* 번호 */}
          <Badge className="badge" color="primary" badgeContent={index + 1} />
        </p>
      ) : null}
      <p className="toolbar">
        {/* 미리보기 */}
        <Anchor
          onClick={() =>
            previewAttachment({
              url: data.url,
              type: data.type,
            })
          }
          text={<SearchOutlined rev={undefined} />}
        />
        {isEditable && (
          <>
            {/*변경하기*/}
            <Anchor onClick={handleClickUpdateAnchor} text={<EditOutlined rev={undefined} />} />
            {/* 삭제하기 */}
            <Anchor onClick={() => deleteAttachment(index)} text={<CloseOutlined rev={undefined} />} />
            {data.type !== ATTACHMENT_TYPE.VIDEO && (
              <input
                className="update-file-input hidden"
                ref={inputRef}
                accept="image/*"
                type="file"
                onChange={(e) => uploadImage(e, index)}
              />
            )}
          </>
        )}
      </p>
    </PreviewStyle>
  );
};

export default Preview;
